/*
 * @Description:融合编辑器路由
 * @Author: he.zhikai
 * @LastEditors: lzy
 * @Date: 2019-10-28 17:15:05
 * @LastEditTime: 2021-03-16 17:24:47
 */
'use strict';
angular.module('editFusionEditorRouterModule', []).config([
    '$stateProvider',
    function($stateProvider) {
        $stateProvider
            .state('fusionnews', {
                // 新闻稿 departdocrelid reportid: 报题id，由策划中心跳转过来带有的
                url:
                    '/fusionnews?iwometadataid&departdocrelid&iwochnldocid&iwoplatform&wzmetadataid&wzchnldocid&wzchannelid&wzsiteid&wzplatform&appmetadataid&appchnldocid&appchannelid&appsiteid&appplatform&newspapertype&paperid&papermetadataid&issave&departmentaldocid&wxmetadataid&wxchnldocid&wxchannelid&wxplatform&fromType&wbmetadataid&baijiahaoarticleid&qiehaoarticleid&articleid&reportid&taskid&from', // from字段代表从哪跳转进来，主要是im可以直接生成新闻稿
                views: {
                    '': {
                        templateUrl: './editingCenter/iWo/fusionEditor/news/fusionNews_tpl.html',
                        controller: 'editFusionNewsCtrl',
                    },
                },
            })
            .state('fusionatlas', {
                // 图集稿
                url:
                    '/fusionatlas?iwometadataid&departdocrelid&iwochnldocid&iwoplatform&wzmetadataid&wzchnldocid&wzchannelid&wzsiteid&wzplatform&appmetadataid&appchnldocid&appchannelid&appsiteid&appplatform&newspapertype&paperid&papermetadataid&issave&departmentaldocid&fromType&baijiahaoarticleid&qiehaoarticleid&reportid&taskid&from', // from字段代表从哪跳转进来，主要是im可以直接生成图集稿
                views: {
                    '': {
                        templateUrl: './editingCenter/iWo/fusionEditor/atlas/fusionAtlas_tpl.html',
                        controller: 'editFusionAtlasCtrl',
                    },
                },
            })
            .state('fusionlinkdoc', {
                // 链接稿
                url:
                    '/fusionlinkdoc?iwometadataid&departdocrelid&iwochnldocid&iwoplatform&wzmetadataid&wzchnldocid&wzchannelid&wzsiteid&wzplatform&appmetadataid&appchnldocid&appchannelid&appsiteid&appplatform&newspapertype&paperid&papermetadataid&issave&departmentaldocid&fromType',
                views: {
                    '': {
                        templateUrl: './editingCenter/iWo/fusionEditor/linkdoc/fusionLinkdoc_tpl.html',
                        controller: 'editFusionLinkdocCtrl',
                    },
                },
            })
            .state('fusionvideo', {
                // 视频稿
                url:
                    '/fusionvideo?iwometadataid&departdocrelid&iwochnldocid&iwoplatform&wzmetadataid&wzchnldocid&wzchannelid&wzsiteid&wzplatform&appmetadataid&appchnldocid&appchannelid&appsiteid&appplatform&newspapertype&paperid&papermetadataid&issave&departmentaldocid&fromType&douyinarticleid&baijiahaoarticleid&qiehaoarticleid&wbmetadataid&articleid&reportid&taskid&from', // from字段代表从哪跳转进来，主要是im可以直接生成视频稿
                views: {
                    '': {
                        templateUrl: './editingCenter/iWo/fusionEditor/video/fusionVideo_tpl.html',
                        controller: 'editFusionVideoCtrl',
                    },
                },
            })
            .state('fusionlive', {
                // 直播稿
                url:
                    '/fusionlive?iwometadataid&departdocrelid&iwochnldocid&iwoplatform&wzmetadataid&wzchnldocid&wzchannelid&wzsiteid&wzplatform&appmetadataid&appchnldocid&appchannelid&appsiteid&appplatform&newspapertype&paperid&papermetadataid&issave&departmentaldocid&fromType',
                views: {
                    '': {
                        templateUrl: './editingCenter/iWo/fusionEditor/live/fusionLive_tpl.html',
                        controller: 'editFusionLiveCtrl',
                    },
                },
            })
            .state('fusionpreview', {
                // 详情页
                url:
                    '/fusionpreview?iwometadataid&departdocrelid&iwochnldocid&iwotype&iwomodalname&appchannelid&appchnldocid&appsiteid&appmetadataid&appplatform&appdoctype&wzchannelid&wzchnldocid&wzsiteid&wzmetadataid&wzplatform&wztypeid&bzmetadata&bzchnlid&paperid&newspapertype&wxmetadataid&wxchnldocid&wxchannelid&wxplatform&mlftype&wbmetadataid&iwodoccollectrelid&fromType&departmentDocId&iwoplatform&douyinarticleid&baijiahaoarticleid&qiehaoarticleid&articleid&fromsearch&mediatype',
                views: {
                    '': {
                        templateUrl: './editingCenter/iWo/fusionEditor/preview/fusionPreview_tpl.html',
                        controller: 'editFusionPreviewCtrl',
                    },
                },
            });
    },
]);
